// src/pages/Auth/ForgotPassword.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
// Use the same stylesheet as Register to match layout/visuals
import "../../styles/Login.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(""); // error message (mirrors Register's naming)
  const [success, setSuccess] = useState(""); // success message

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setSuccess("");

    if (!email.trim()) {
      setMsg("Please enter your email address.");
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.post(
        `${BASE_URL}/api/auth/forgot-password`,
        { email },
        { headers: { "Content-Type": "application/json" } }
      );

      setSuccess(
        data?.message ||
          "✔️ Reset link sent. Please check your inbox (and spam)."
      );
    } catch (err) {
      setMsg(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to send reset email"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg">
      <div className="login-card">
        <h3 className="auth-title">Reset your password</h3>

        <form onSubmit={handleSubmit} className="auth-form" noValidate>
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            autoComplete="email"
            disabled={loading}
          />

          <button
            type="submit"
            className="btn btn-primary auth-submit"
            disabled={loading}
            style={{ marginTop: 10 }}
          >
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>

        {msg && <p className="auth-error">{msg}</p>}

        {success && (
          <div className="success" style={{ marginTop: 12 }}>
            <p>{success}</p>
          </div>
        )}

        <div className="auth-links">
          Remembered your password?{" "}
          <Link to="/login" className="link-cta">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
}
